import styled from 'styled-components';

export const OverlayTriggerWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const TriggeringElementWrapper = styled.div`
  position: relative;
`;

export const OverlayWrapper = styled.div`
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  z-index: 1;
`;
